module.exports = __webpack_public_path__ + "img/Vivi.46587bd.png";